import axios from 'axios';
import "/node_modules/bxslider/src/css/jquery.bxslider.css";
import "./styles-productbox.css";
import "./wexcategory.css";
import "./wexcheckout.css";
import "./wexmypage.css";
import "./wexcontent.css";
import "./reseller.css";
import "./wexstyles.css";
import "/node_modules/jquery-typeahead/src/jquery.typeahead.css";
import "./font-awesome-4.7.0/fonts/FontAwesome.otf";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.eot";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.svg";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.ttf";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.woff";
import "./font-awesome-4.7.0/fonts/fontawesome-webfont.woff2";
//import Alpine from 'alpinejs';
import {  hideTxtBarAtPos,
  deviceWidthToHideTxtBar,
  isClosePopupWhenScroll,
  txtBarMaxHeight,
  touchEnabled
} from "./config";

import {loadProductLists} from './product_list';
import {loadNotifyStockPopup, showSlider, setProductNavigation, storeProductNavigationSession, getProductNavigationSession } from './product_item';
import {getBasket, add2basket, reloadFavoritePopupHTML,selectCountryToggleHandler} from './basket';
import {loadLoginPopup,
  logoutCustomer,
  bindMyPageEvents,
  loadSubscriptionPopup,
  bindRegisterMemberEvents,
  checkLoggedCustomer,
  gotoMyPage,
  checkProductIsFv,
  renderAdditionalFullWishlist,
  openSellerPopup
} from './customer';
import {bindCheckoutEvents} from './checkout';
import {bindSearchEvents} from './search';
import {showAds, loadContentProductList, loadContentPopup } from './content';
import globalEvent from "./eventEmitter";

function freezeUI() {
  $("body").LoadingOverlay("show",{
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false
  });
}

function unFreezeUI(){
  $("body").LoadingOverlay("hide",true);
}

function closePopup() {
  unFreezeUI();

  // close popup-basket
  const basketPopup=$("div.popup-basket");
  if(basketPopup && basketPopup.length){
    basketPopup[0].style.display="none";
  }

  // close popup-favorite
  const favoritePopup=$("div.popup-favorite");
  if(favoritePopup && favoritePopup.length){
    favoritePopup[0].style.display="none";
  }
  // close popup-select-country
  const selectCountryPopup=$("div.popup-select-country");
  if(selectCountryPopup && selectCountryPopup.length){
    selectCountryPopup[0].style.display="none";
  }
}

window.addEventListener('click', function(event){
	const mmenu = document.getElementById('mobile_menu');
	if (event.target != mmenu && $(event.target).closest("div.mobile-menu-wrapper")[0] != mmenu){
    closeMobileMenu();
  }
});

function closeMobileMenu() {
  unFreezeUI();
  var mobileMenu = $("div.mobile-menu-wrapper");
  if(mobileMenu && mobileMenu.length) mobileMenu[0].style.display="none";
}

function bindSelectCountryEvents() {
  $("div#current_country").on("click", selectCountryToggleHandler);
  $("div#selectPopupCountry input").on("click", function(evt) {
    evt.stopPropagation();
    const url = "/customer/country-change";
    axios({
      url:url,
      method:'POST',
      data:{
        selected_country: evt.target.value, redirect_url: "/"
      }
    }).then(function(res) {
      console.log(res);
      if(res.data && res.data.status){
        location.href=res.data.redirect_url;
      }
    }).catch(function(err){
      console.log(err);
    });      
  });
}

function mobileMenuEventsBinding() {
  $(".menu-btn").on("click", function(evt) {
    freezeUI();
    evt.stopPropagation();
    if($(".mobile-menu-wrapper").length){
      if($(".mobile-menu-wrapper")[0].style.display == 'block'){
        $(".mobile-menu-wrapper").css({display: 'none'});
      } else {
        var basketEle=$("div.popup-basket");
        if(basketEle && basketEle.length){
          basketEle[0].style.display="none";
        }
        $(".mobile-menu-wrapper").css({display: 'block'});
      }
    }
  });

  $("button.sub-toogle").on("click", function(evt) {
    evt.stopPropagation();
    if($(this).closest("li").find("div.menu_level2").length && $(this).closest("li").find("div.menu_level2")[0].style.display=="block") {
      $(this).closest("li").find("div.menu_level2")[0].style.display="none";
      $(this).find("i").removeClass("fa-angle-right").addClass("fa-angle-down");
    } else if ($(this).closest("li").find("div.menu_level2").length){
      $(this).closest("li").find("div.menu_level2")[0].style.display="block";
      $(this).find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
    }
  });

  $('#header,#wex_wrap,button.wex-btn-close').on("click", function(evt){
    unFreezeUI();
    var ele=$("div.mobile-menu-wrapper");
    if(ele && ele.length){
      ele[0].style.display="none";
    }
  });
}

function isCheckoutPage() {
  if($("#checkout_page").length > 0) return true;
  return false;
}
function bindAdd2BasketEvent() {
  $("div.product-direct-search-container button.btn-addcart").on("click",function(evt){
    evt.stopPropagation();
    if(!$(this).hasClass("read-more")) add2basket(this,$(this).data("pid"),"direct_search");
    else {
      location.href=$(this).closest(".product-wrapper").find("a.product-url").attr("href");
    }
  });
  $("div.product-search-container button.btn-addcart").on("click",function(evt){
    evt.stopPropagation();
    if(!$(this).hasClass("read-more")) add2basket(this,$(this).data("pid"),"search");
    else {
      location.href=$(this).closest(".product-wrapper").find("a.product-url").attr("href");
    }
  });
}

function bindProductNavigation() {
  try {
    const productDetailId = $(".wex-container .product-detail").attr("id");
    if (!productDetailId || isNaN(productDetailId)) return;
    let productNavs = getProductNavigationSession(`nav_${document.location.pathname}`);
    if (!productNavs || !productNavs.length) return;
    const currProductIdx = productNavs.findIndex(ele => ele?.product_id == productDetailId);
    if (currProductIdx == -1) return;
    const nextProductUrl = productNavs[currProductIdx+1] ? `${/https\:\/\//gm.test(productNavs[currProductIdx+1]?.url) ? "" : "/"}${productNavs[currProductIdx+1]?.url}` : "";
    const prevProductUrl = productNavs[currProductIdx-1] ? `${/https\:\/\//gm.test(productNavs[currProductIdx-1]?.url) ? "" : "/"}${productNavs[currProductIdx-1]?.url}` : "";
    if (nextProductUrl) {
      $(".product-nav a.next").attr("href", nextProductUrl);
      $(".product-nav a.next").css("display", "flex");
    }
    if (prevProductUrl) {
      $(".product-nav a.prev").attr("href", prevProductUrl);
      $(".product-nav a.prev").css("display", "flex");
    }
    $("div.product-nav a").on("click", function(evt) {
      evt.preventDefault();
      var curr = window.sessionStorage.getItem(`nav_${document.location.pathname}`);
      if (!curr) return;
      var url = null;
      try {
        curr = JSON.parse(curr);
        var url = new URL($(this).attr("href"));
      } catch (e1) {
        console.error(e1);
      }
      window.sessionStorage.setItem(`nav_${url?.pathname ? url?.pathname : $(this).attr("href")}`, JSON.stringify(curr));
      window.location.href = $(this).attr("href");
    })
  } catch (e) {
    console.error(e);
  }
}

function bindProductCellToNavigationAction() {
  $("div.product-search-container div.product-cell").on("click", function(event) {
    return storeProductNavigationSession(event, $(this).children().find("a.product-url").attr("href"));
  })
}

$(document).ready(function() {
  //window.Alpine = Alpine
  //Alpine.start();
  $(".mobile-menu-wrapper").css({display: 'none'});
  $('button.search-clear').css({display: "none"});
  $('input[name="q"]').on('keyup', function(event){
    var ele=$('button.search-clear');
    if($('input[name="q"]').val() != '') ele.css({display: ""});
    else ele.css({display: "none"});
  });

  $('button.search-clear').on("click", function(evt){
    evt.stopPropagation();
    var ele=$('button.search-clear');
    $('input[name="q"]').val("");
    ele.css({display: "none"});
  });

  const observer=lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
  $("button[name='member_register'],button[name='customer_mypage']").on("click",function(evt){
    evt.stopPropagation();
    closePopup();
    location.href = $(this).data("url");
  });
  $("button[name='notifyStockSub']").on("click",function(evt){
    evt.stopPropagation();
    loadNotifyStockPopup(this);
  });

  $("button[name='from_checkout']").on("click",function(evt){
    evt.stopPropagation();
    closePopup();
    closeMobileMenu();
    loadLoginPopup(this);
  });

  $("div#customer_logged_id").on("click",function(evt){
    evt.stopPropagation();
    closePopup();
    closeMobileMenu();

    // if customer icon action is logout => logout current user
    // action is logout when user is in my page
    if ($(this).data('action') === 'logout') {
      logoutCustomer(this);
    } else if(Number($("div#customer_logged_id").data("cust-id")) > 0) {
      gotoMyPage(this)
    } else {
      loadLoginPopup(this);
    }
  });

  $("button[name='customer_login']").on("click",function(evt){
    if(Number($("div#customer_logged_id").data("cust-id")) > 0) gotoMyPage(this);
    else loadLoginPopup(this);
  });

  $("a[name='btn_signin_seller']").on("click", function(evt){
    evt.stopPropagation();
    openSellerPopup(this);
  });

  $("button[name='btn_logout'], button[name='cust_info']").on("click",function(evt){
    evt.stopPropagation();
    logoutCustomer(this);
  });

  if(!isCheckoutPage()) {
    getBasket(); // load basket
  }else{
    $("img.shopping-basket").closest("div.item").css({display: 'none'});
    $("div.basket-item-count").css({display: 'none'});
    $("div.fav-item-count").css({right: '-4px'});

    reloadFavoritePopupHTML(); // load favorite numbers for checkout page
  }

  // listen for event wishlist-num-changed => to reload the wishlist component on header
  globalEvent.on("wishlist-num-changed", () => {
    reloadFavoritePopupHTML();
  })

  checkLoggedCustomer();
  bindSelectCountryEvents();
  bindAdd2BasketEvent();
  mobileMenuEventsBinding();
  loadProductLists();
  bindCheckoutEvents();
  bindMyPageEvents();
  showAds();
  bindSearchEvents();
  bindRegisterMemberEvents();
  bindProductNavigation();
  bindProductCellToNavigationAction();
  checkProductIsFv();
  renderAdditionalFullWishlist();
  $(window).on("load", function() { // can also use window.addEventListener('load', (event) => {
    loadContentProductList();
    loadSubscriptionPopup();
    loadContentPopup();
  });

  $(window).on("scroll", function(){
    if(isClosePopupWhenScroll) {
      closePopup();
      if($(window).width() >= deviceWidthToHideTxtBar) closeMobileMenu();
    }
    if($(document).scrollTop() > hideTxtBarAtPos && $(window).width() < deviceWidthToHideTxtBar) {
      $("#txtbar").css({"max-height": "0px"});
      $("#header").css({"transition":"top .2s ease-out","top": "0px"});
    }else{
      $("#txtbar").css({"max-height": `${txtBarMaxHeight}px`});
      $("#header").css({"transition":"top .2s ease-out","top": `${txtBarMaxHeight}px`});
    }
    var pKey=`paging_${document.location.pathname}`;
    if (!window.sessionStorage) return null;
    var storeData = window.sessionStorage.getItem(pKey);
    if (storeData) {
      try{
        storeData = JSON.parse(storeData);
        storeData.data.pos=$(window).scrollTop();
        window.sessionStorage.setItem(pKey, JSON.stringify(storeData));
      }catch(err){

      }
    }
  });

  document.querySelectorAll('*').forEach(el => {
    if (el.offsetWidth > document.documentElement.offsetWidth) {
      console.log('Found the worst element ever: ', el);
    }
  });

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // rerender wishlist even loaded from cached
      renderAdditionalFullWishlist();

      // rerender basket even loaded from cached
      getBasket()
    } else {
      console.log('This page was loaded normally.');
    }
  });

  window.addEventListener('pagehide', function(event) {
    if (event.persisted === true) {
     console.log('This page *might* be entering the bfcache.');
    } else {
      console.log('This page will unload normally and be discarded.');
    }
  });
});
